

import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage } from '@ionic/vue';
import { ellipse, square, triangle, radio, disc,person } from 'ionicons/icons';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Tabs',
  

  components: { IonLabel, IonTabs, IonTabBar, IonTabButton, IonIcon, IonPage },
  setup() {
    return {
      ellipse, 
      square, 
      triangle,
      radio,
      disc,
      person
    }
  },
  
data() {
  return {
    playerLink: `playlist/37i9dQZEVXbMDoHDwVN2tF`,
  }
},
mounted() {
    

      window.addEventListener('player-link-localstorage-changed', event => {
           if(localStorage.getItem('player-link') !== null){
             this.playerLink = localStorage.getItem('player-link') || '{}';
           }
          }, false);

//   window.addEventListener('player-link-localstorage-changed', function() {  
  
//   document.getElementById("spotifyiFrame").src= "OK";

// //   if (localStorage.getItem('player-link') !== undefined) {
// //     // continue - error suppressed when used in this way.
// //     console.log(document.getElementById('spotifyiFrame'))

// // }


//   });

 
}
})

  
